import { render, staticRenderFns } from "./editDocFileImage.vue?vue&type=template&id=b44378f8&scoped=true&"
import script from "./editDocFileImage.vue?vue&type=script&lang=js&"
export * from "./editDocFileImage.vue?vue&type=script&lang=js&"
import style0 from "./editDocFileImage.vue?vue&type=style&index=0&id=b44378f8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44378f8",
  null
  
)

export default component.exports